import { Signal } from '@angular/core';

import { TableComponent } from '../table.component';
import { TableMobileComponent } from '../../table-mobile';

export abstract class BaseTable {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  abstract tableRef: Signal<TableComponent<any> | TableMobileComponent<any>>;

  setPaginator(pageIndex: number, pageSize: number): void {
    this.tableRef()?.setPaginator(pageIndex, pageSize);
  }

  setDefaultPageSize(pageSize: number): void {
    this.tableRef()?.setDefaultPageSize(pageSize);
  }
}
